import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-credit-card" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Pagamento ")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-d-flex p-flex-column p-jc-center p-ai-center" }
const _hoisted_5 = { class: "p-d-flex p-ai-center p-mb-3" }
const _hoisted_6 = { class: "p-my-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1 p-as-start" }, " (Iva inclusa) ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      (!_ctx.hasToPay)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "effettuato"))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.hasToPay 
              ? 'Totale da pagare'
              : 'Totale pagato') + ": " + _toDisplayString(_ctx.order?.payment_amount) + "€ ", 1),
          _hoisted_7
        ]),
        (_ctx.hasToPay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-credit-card",
              label: "Procedi con il pagamento",
              loading: _ctx.loading,
              onClick: _ctx.checkout
            }, null, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}